// extracted by mini-css-extract-plugin
export default {"container":"DesktopOverlay-module__container-N2nVcg","button":"DesktopOverlay-module__button-mUrB0f","icon":"DesktopOverlay-module__icon-lzfp5A"};